import { NavItem } from "../models/ui/profile-nav-item.model";
import { 
  UserProfileNavItems, 
  PropertyProfileNavItems, 
  MemberProfileNavItems, 
  OrganizationProfileNavItems 
} from "../enums/nav-items.enum";
import { OrganizationPermission, PaymentsPermission } from "../enums/permissions.enums";
import { BalancesPermission } from "../enums/permissions.enums";
import { MessagePermission } from "../enums/permissions.enums";

export class ProfileConstants {

    //#region User Profile
    public static USER_PROFILE_NAV_ITEMS = (): NavItem[] => [
    { 
        id: UserProfileNavItems.Overview, 
        label: 'Overview', 
        description: 'View your account overview and profile completion status.',
        active: true 
      },
      { 
        id: UserProfileNavItems.Settings, 
        label: 'Settings', 
        description: 'Manage your account settings and preferences.',
        active: false 
      },
      { 
        id: UserProfileNavItems.Security, 
        label: 'Security', 
        description: 'Configure your security settings and authentication methods.',
        active: false 
      },
      {
        id: UserProfileNavItems.ActivityLogs, 
        label: 'Activity Logs', 
        description: 'View system logs and audit trails.',
        active: false 
      }
    ];
    //#endregion
    
    //#region Property Profile
    public static PROPERTY_PROFILE_NAV_ITEMS = (): NavItem[] => [
      {
        id: PropertyProfileNavItems.Contacts,
        label: 'Contacts',
        description: 'View and manage contacts associated with the property.',
        active: true
      },
      { 
        id: PropertyProfileNavItems.PropertyData, 
        label: 'Property Data', 
        description: 'View your property data and details.',
        active: false 
      },
      {
        id: PropertyProfileNavItems.Invoicing,
        label: 'Invoicing',
        description: 'View outstanding invoices and financial history for the property.',
        active: false,
        permission: [BalancesPermission.Read],
        ownerBypass: true
      },
      {
        id: PropertyProfileNavItems.PaymentHistory,
        label: 'Payment History',
        description: 'View payment history and transaction records for the property.',
        active: false,
        permission: [BalancesPermission.Read],
        ownerBypass: true
      },
      {
        id: PropertyProfileNavItems.ActivityLogs,
        label: 'Activity Logs',
        description: 'View system logs and audit trails.',
        active: false
      }
    ];
    //#endregion

    //#region Member Profile
    public static MEMBER_PROFILE_NAV_ITEMS = (): NavItem[] => [
      {
        id: MemberProfileNavItems.Invoicing,
        label: 'Invoicing',
        description: 'View outstanding invoices for the member.',
        active: true,
        permission: [BalancesPermission.Read],
        ownerBypass: true
      },
      {
        id: MemberProfileNavItems.PaymentHistory,
        label: 'Payment History',
        description: 'View payments made by the member.',
        active: false,
        permission: [PaymentsPermission.Read],
        ownerBypass: true
      },
      {
        id: MemberProfileNavItems.Properties,
        label: 'Properties',
        description: 'View and manage properties associated with the member.',
        active: false
      },
      {
        id: MemberProfileNavItems.CommunicationHistory,
        label: 'Communication History',
        description: 'View emails sent to the member and their latest delivery status.',
        active: false,
        permission: [MessagePermission.Read],
        ownerBypass: true
      },
      {
        id: MemberProfileNavItems.ActivityLogs,
        label: 'Activity Logs',
        description: 'View system logs and audit trails.',
        active: false
      },
      {
        id: MemberProfileNavItems.Settings,
        label: 'Settings',
        description: 'Manage your own directory visibility.',
        active: false,
        ownerOnly: true
      }
    ];
    //#endregion

    //#region Organization Profile
    public static ORGANIZATION_PROFILE_NAV_ITEMS = (): NavItem[] => [
      {
        id: OrganizationProfileNavItems.Overview,
        label: 'Overview',
        description: 'View organization details and information.',
        active: true
      },
      {
        id: OrganizationProfileNavItems.Settings,
        label: 'Settings',
        description: 'Manage organization settings and preferences.',
        active: false,
        permission: [OrganizationPermission.Update]
      },
      {
        id: OrganizationProfileNavItems.Contacts,
        label: 'Contacts',
        description: 'View and manage contacts for the organization.',
        active: false,
        permission: [OrganizationPermission.Update]
      },
      {
        id: OrganizationProfileNavItems.Addresses,
        label: 'Addresses',
        description: 'View and manage addresses for the organization.',
        active: false,
        permission: [OrganizationPermission.Update]
      },
      {
        id: OrganizationProfileNavItems.ActivityLogs,
        label: 'Activity Logs',
        description: 'View system logs and audit trails.',
        active: false,
        permission: [OrganizationPermission.Update]
      }
    ];
    //#endregion
  }
